// extracted by mini-css-extract-plugin
export default {"imageWrapper":"gE-z","hovered":"hE-z","hoverImage":"iE-z","mainImage":"jE-z","imageNoBackground":"kE-z","fullSizeImage":"lE-z"};